export const API_BASE_URL =
  "https://search-beta.chorusaccess.org/funder-service/api/v1";
